
import ProductListFilterModule from '@/store/modules/ProductListFilterModule';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'ProductTable',
})
export default class ProductTable extends Vue {
    private hasScroll = false;
    
    get expanded() {
        return ProductListFilterModule.EXPANDED_TABLE;
    }

    get tableId() {
        return (this as any)._uid;
    }

    get currentTableId() {
        return ProductListFilterModule.CURRENT_TABLE_ID;
    }
    
    private mounted() {

        ProductListFilterModule.UPDATE_CURRENT_TABLE_ID(this.tableId);
        
        ProductListFilterModule.GET_EXPANDED_TABLE();
        if (this.expanded) {
            this.resize();
        }
        window.addEventListener('resize', this.resize);
        const scrollContainer = this.$el.querySelector('.product-table');
        if (!scrollContainer)
            return;

        this.hasScroll = scrollContainer.scrollWidth > scrollContainer.clientWidth;

        const scrollWatchElement = document.querySelector('.product-table-body-specifications');
        const scrollApplyElement = document.querySelector('.product-table-header-specifications');
        if (scrollWatchElement && scrollApplyElement) {
            
            scrollWatchElement.addEventListener('scroll', () => {
                scrollApplyElement.scrollLeft = scrollWatchElement.scrollLeft;
            });
        }

        setTimeout(() => {
            this.updateCloneTable();
            this.$nextTick(() => {
                this.displayTableClone();
            });
            document.querySelector('.product-table')?.addEventListener('scroll', () => {
                document.querySelector('.product-table-clone').scrollLeft = (document.querySelector('.product-table') as HTMLElement).scrollLeft;
            }); 
            window.addEventListener('scroll', this.displayTableClone.bind(this));
        }, 1000);
    }

    private updateCloneTable() {
        const tableContainer = document.querySelector('.product-table') as HTMLElement;
        if (!tableContainer) return;

        const headerClone = document.querySelector('.product-table-clone') as HTMLElement;
        if (!headerClone) return;

        headerClone.style.top = `${this.getHeaderHeight()}px`;

        const header = tableContainer.querySelector('thead') as HTMLElement;
        if (!header) return;

        const headerCells = header.querySelectorAll('th');
        if (!headerCells || headerCells.length === 0) return;
        const cloneCells = headerClone.querySelectorAll('th');

        headerCells.forEach((cell, index) => {
            const cloneCell = cloneCells[index] as HTMLElement;
            if (cloneCell) {
                this.setCloneTableHeaderCellWidth(cell as HTMLElement, cloneCell);
            }
        });
    }

    private getHeaderHeight(): number {
        const desktopHeader = document.querySelector('.cbx-navbar-sticky') as HTMLElement;
        const mobileHeader = document.querySelector('.cbx-navbar-sticky') as HTMLElement;
        return desktopHeader?.offsetHeight || mobileHeader?.offsetHeight || 0;
    }

    private displayTableClone(): void {
        const table = document.querySelector('.product-table') as HTMLElement;
        const clonedHeader = document.querySelector('.product-table-clone') as HTMLElement;

        if (!table || !clonedHeader) return;

        const rect = table.getBoundingClientRect();

        if (rect.top <= this.getHeaderHeight() - 10 && rect.bottom > 0) {
            clonedHeader.style.display = 'block';
        } else {
            clonedHeader.style.display = 'none';
        }
    }

    private setCloneTableHeaderCellWidth(cell: HTMLElement, cloneCell: HTMLElement) {
        if (!cell || !cloneCell) return;

        const width = cell.offsetWidth;
        cloneCell.style.width = `${width}px`;
        cloneCell.style.minWidth = `${width}px`;
        cloneCell.style.maxWidth = `${width}px`;
    }

    private beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }

    private resize() {
        const tableContainer = document.querySelector('.product-table') as HTMLElement;
        const cloneTableContainer = document.querySelector('.product-table-clone') as HTMLElement;
        let offsetAsPixels = "0";
        if (this.expanded) {
            const offset = tableContainer.offsetLeft / 1.5;
            offsetAsPixels = `${offset-2*offset}px`;
        }
        tableContainer.style.marginLeft = offsetAsPixels;
        tableContainer.style.marginRight = offsetAsPixels;
        cloneTableContainer.style.marginLeft = offsetAsPixels;
        cloneTableContainer.style.marginRight = offsetAsPixels;
        setTimeout(() => {
            this.updateCloneTable();
        }, 1000);
    }

    @Watch('expanded')
    private onExpandedChange() {
        this.resize();
    }

    @Watch('currentTableId')
    private onTableIdChange() {
        if (this.currentTableId !== this.tableId) {
            this.$destroy();
        }
    }

}
